module.exports = __webpack_public_path__ + "img/GF3sat.324f009e.png";